import { IPersonSearchResultItem } from "../../models/Person";
import { IStudentCourseEqualizationFile } from "../../models/StudentCourseEqualization";
import { StudentCourseEqualizationService } from "../../services/student-course-equalization.service";
import { AppService } from "../../services/app.service";
import * as FileSaver from 'file-saver';

const data: {
    person?: IPersonSearchResultItem
} = {};

export const permissions = {
    edit: 'STUDENT_COURSE_EQUALIZATION.EDIT',
    setStudent: 'STUDENT_COURSE_EQUALIZATION.SET_STUDENT',
    createProject: 'STUDENT_COURSE_EQUALIZATION.PROJECT'
};

export const store = {
    getStudent(): IPersonSearchResultItem {
        return data.person;
    },

    setStudent(student: IPersonSearchResultItem) {
        data.person = student;
    }
};

const expanded: any[] = [];

export const util = {
    downloadAttachment(app: AppService, service: StudentCourseEqualizationService, attachment: IStudentCourseEqualizationFile) {
        app.addLoading(service.getAttachment(attachment.Id)).subscribe(result => {
            FileSaver.saveAs(result, attachment.FileName);
        });
    },
    toggle(row: any) {
        const ix = expanded.indexOf(row);

        if (ix == -1) {
            expanded.push(row);
        } else {
            expanded.splice(ix, 1);
        }
    },
    isExpanded(row: any): boolean {
        return expanded.indexOf(row) > -1;
    },
    compactFileName(fileName: string, maxLength: number): string {
        if (!fileName) return '';

        const parts = fileName.split('.');

        let result: string = '';

        if (parts.length > 1) {
            const ext = parts.pop();
            const name = parts.join('.');

            if (name.length <= maxLength) return fileName;

            result = name.substr(0, maxLength) + '...' + ext;
        } else {
            result = parts[0].substr(0, maxLength);
        }

        return result;
    }
};

